<template>
    <article
        class="flex min-h-32 min-w-0 items-center gap-4 rounded-2xl bg-white p-4 text-right shadow-sm ring-1 ring-slate-200 transition duration-200 hover:-translate-y-0.5 hover:shadow-md sm:p-5"
    >
        <div
            class="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl"
            :class="iconClasses"
        >
            <v-icon size="24">{{ icon || 'mdi-wallet' }}</v-icon>
        </div>
        <div class="min-w-0 flex-1">
            <p class="truncate text-sm font-medium leading-6 text-slate-500">
                {{ title }}
            </p>
            <div class="mt-2 flex min-w-0 flex-wrap items-baseline gap-x-2 gap-y-1">
                <span class="break-all text-xl font-bold leading-7 text-slate-900 sm:text-2xl">
                    {{ formattedValue }}
                </span>
                <span v-if="unitLabel" class="text-xs font-medium text-slate-500">
                    {{ unitLabel }}
                </span>
            </div>
        </div>
    </article>
</template>

<script>
export default {
    name: 'WalletCard',
    props: {
        title: {
            type: String,
            required: true
        },
        value: {
            type: [Number, String],
            required: true
        },
        icon: {
            type: String,
            default: 'mdi-wallet'
        },
        type: {
            type: String,
            default: 'User'
        },
        unit: {
            type: String,
            default: ''
        }
    },
    computed: {
        formattedValue() {
            const value = Number(this.value)
            return Number.isFinite(value)
                ? new Intl.NumberFormat('fa-IR', { maximumFractionDigits: 8 }).format(value)
                : this.value
        },
        iconClasses() {
            const classes = {
                User: 'bg-sky-50 text-sky-700',
                USDT: 'bg-violet-50 text-violet-700',
                Wallet: 'bg-emerald-50 text-emerald-700'
            }
            return classes[this.type] || 'bg-cyan-50 text-cyan-700'
        },
        unitLabel() {
            if (this.unit) return this.unit
            const labels = {
                User: 'نفر',
                Wallet: 'ریال',
                USDT: 'USDT'
            }
            return labels[this.type] || ''
        }
    }
}
</script>
